<template>
  <svg
      id="agency-central-graphic"
      height="40"
      version="1.1"
      viewBox="0 0 40.20046 40"
      width="40.200462"
      xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:cc="http://creativecommons.org/ns#"
      xmlns:dc="http://purl.org/dc/elements/1.1/"
      xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
      xmlns:svg="http://www.w3.org/2000/svg"
  >
    <defs
        id="agency-central-graphic-defs6"
    ><clipPath
         id="agency-central-graphic-clipPath16"
         clipPathUnits="userSpaceOnUse"><path
           id="agency-central-graphic-path18"
           d="m 0,595.28 841.89,0 L 841.89,0 0,0 0,595.28 Z" /></clipPath></defs>
    <g
        id="agency-central-graphic-g10"
        transform="matrix(1.25,0,0,-1.25,-279.82112,376.89249)"
    ><g
         id="agency-central-graphic-g4296"><path
           id="agency-central-graphic-path22"
           d="m 253.83337,299.71724 0,-6.16625 c -2.78995,4.75777 -7.97257,7.963 -13.89572,7.963 -8.86673,0 -16.08075,-7.17745 -16.08075,-16.00028 0,-8.82114 7.21402,-15.99972 16.08075,-15.99972 5.92315,0 11.10577,3.20636 13.89572,7.96301 l 0,-6.16513 2.1839,0 0,28.40537 -2.1839,0 z m -13.89572,-28.0306 c -7.66195,0 -13.89572,6.20339 -13.89572,13.82707 0,7.62425 6.23377,13.82651 13.89572,13.82651 7.66251,0 13.89572,-6.20226 13.89572,-13.82651 0,-7.62368 -6.23321,-13.82707 -13.89572,-13.82707"
           style="fill:#006396;fill-opacity:1;fill-rule:nonzero;stroke:none" /><path
        id="agency-central-graphic-path26"
        d="m 246.67275,282.87176 c -1.06185,-2.66953 -3.67792,-4.56701 -6.73515,-4.56701 -3.99585,0 -7.24554,3.2345 -7.24554,7.20896 0,3.97503 3.24969,7.20953 7.24554,7.20953 3.05723,0 5.6733,-1.89692 6.73515,-4.5687 l 2.30826,0 c -1.14963,3.89062 -4.76564,6.74135 -9.04341,6.74135 -5.20007,0 -9.43001,-4.208 -9.43001,-9.38218 0,-5.17417 4.22994,-9.38217 9.43001,-9.38217 4.27777,0 7.89378,2.85072 9.04341,6.74022 l -2.30826,0"
        style="fill:#ff6005;fill-opacity:1;fill-rule:nonzero;stroke:none"
    />
      </g>
      </g>
  </svg>
</template>

<script>
export default {
  name: "IconLogoGraphic"
}
</script>
